// TODO Rename to basket once we remove old basket
import {action, observable, runInAction} from 'mobx';
import * as Sentry from '@sentry/react';

import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from './_util/api-request';

import isValidException from 'utils/isValidException';

class AppointmentsRecommendationGetState extends APIRequestState {
  getRequest(appointmentId) {
    return this.ctx.sdk.get(`/appointments/${appointmentId}/recommendation`);
  }
}

class AppointmentsRecommendationBookState extends APIRequestState {
  putRequest(appointmentId) {
    return this.ctx.sdk.post(`/appointments/${appointmentId}/clone-to-basket/from-recommendation`);
  }
}

class AppointmentsRecommendationState {
  @lazyInitialize @nonenumerable appointmentsRecommendationGet = new AppointmentsRecommendationGetState(this.ctx);
  @lazyInitialize @nonenumerable appointmentsRecommendationBook = new AppointmentsRecommendationBookState(this.ctx);


  @action reset() {

  }

  @nonenumerable
  listeners = [];

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });

    // this.listeners.push();
  }

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default AppointmentsRecommendationState;



// WEBPACK FOOTER //
// ./spa/state/appointments-recommendation.jsx